import { Box, Typography } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { useTranslation } from 'react-i18next';
import { MultichannelConversation } from '../services/responses/multichannel.response';

const ICON: Record<string, typeof MicIcon> = {
    audio: MicIcon,
    image: PhotoCameraOutlinedIcon,
    video: VideocamOutlinedIcon,
};

const LABEL: Record<string, string> = {
    audio: 'crmMultichannel.previaAudio',
    image: 'crmMultichannel.previaImagem',
    video: 'crmMultichannel.previaVideo',
};

interface Props {
    conversation: MultichannelConversation;
    color: string;
    fontWeight: number;
}

/// Prévia da última mensagem como no WhatsApp: anexo vira ícone e nome; com legenda, ícone antes.
export const LastMessagePreview = ({ conversation, color, fontWeight }: Props) => {
    const { t } = useTranslation();

    const text = conversation.lastMessage?.trim();
    const attachment = conversation.lastMessageAttachmentType;

    if (!attachment) {
        return (
            <Typography variant="caption" noWrap sx={{ flex: 1, color, fontWeight }}>
                {text || '—'}
            </Typography>
        );
    }

    const Icon = ICON[attachment] ?? InsertDriveFileOutlinedIcon;

    return (
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 0.4, color }}>
            <Icon sx={{ fontSize: 14, flexShrink: 0 }} />
            <Typography variant="caption" noWrap sx={{ color, fontWeight }}>
                {text || t(LABEL[attachment] ?? 'crmMultichannel.previaArquivo')}
            </Typography>
        </Box>
    );
};
